<ng-container *ngTemplateOutlet="templateRef; context: routingContext"></ng-container>

<ng-template #routerRef let-commands="commands" let-fragment="fragment" let-params="queryParams">
  <a
    [ngClass]="{'link--block': isBlock, 'link--flex': isFlex}"
    [class]="extraClass"
    (click)="onClick($event)"
    [attr.itemprop]="microData ? microData : null"
    [routerLink]="commands"
    [fragment]="fragment"
    [queryParams]="params"
    [attr.target]="targetAttr"
    [attr.aria-label]="ariaLabel ? ariaLabel : null"
    [target]="blank ? '_blank' : '_self'"
    rel="noopener"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
</ng-template>

<ng-template #absoluteRef>
  <a
    [ngClass]="{'link--block': isBlock, 'link--flex': isFlex}"
    [class]="extraClass"
    (click)="onClick($event)"
    [attr.itemprop]="microData ? microData : null"
    [attr.href]="url"
    [attr.target]="targetAttr"
    [attr.aria-label]="ariaLabel ? ariaLabel : null"
    [target]="blank ? '_blank' : '_self'"
    rel="noopener"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
</ng-template>

<ng-template #anchoredRef>
  <button
    [ngClass]="['clickable', 'resetButton', 'refButton', extraClass]"
    (click)="navigate($event)"
    role="button"
    tabindex="0"
    [attr.aria-label]="ariaLabel ? ariaLabel : null"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </button>
</ng-template>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
